import React from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import AboutAmber from "../components/AboutAmber";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import {
  VisionMissionSection,
  InfrastructureSection,
  ProductMixSection,
  CertificationsSection,
} from "../components/Sections";

const Home = () => {
  return (
    <main className="min-h-screen bg-white">
      <Navbar />
      <div id="home">
        <HeroSection />
      </div>
      <AboutAmber />
      <VisionMissionSection />
      <InfrastructureSection />
      <ProductMixSection />
      <CertificationsSection />
      <ContactSection />
      <Footer />
    </main>
  );
};

export default Home;
